import * as React from "react";
import { useState, useRef, useEffect, lazy } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  checkExisting,
  setActionType,
  setGeneratedNeedId,
  setIsChatModalOpen,
  setIsZoomStarted,
  setLink,
  setSearchPopUp,
  setShowCallDialog,
} from "../../../../redux/slices/SearchBarSlice";
import {
  resetFormState,
  setAlternativePhoneOne,
  setDescription,
  setEmail,
  setEventDetails,
  setNoOtherVendors,
  setOtherVendors,
  setPhone,
  setZipcode,
} from "../../../../redux/slices/RequestFormSlice";
import {
  setDropdownOpen,
  setIsModalOpen,
} from "../../../../redux/slices/bwvSlice";
import { userAction } from "../../../../redux/slices/userSlice";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { countryCodes } from "../../../CountryCodes";
import { toast } from "react-toastify";
import { getAllMessages, sendMessage } from "../../Data";
import { useSocket } from "../../../../contexts/SocketContext";
import axiosClient from "../../../../axios-client";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import AutoNeedForm from "./AutoNeedForm";
import AutoNeedOtp from "./AutoNeedOtp";
import { FaWindowClose } from "react-icons/fa";

// Lazy-load utilities
const loadUtilities = async () => {
  const { default: axiosClient } = await import("../../../../axios-client");
  const {
    makeCall,
    postRequest,
    sendMsgMail,
    virtualTourClick,
    postOtherVendors,
  } = await import("../../Data");
  const { GetZoomLink } = await import("../../Data2");
  return {
    axiosClient,
    makeCall,
    postRequest,
    postOtherVendors,
    sendMsgMail,
    virtualTourClick,
    GetZoomLink,
    toast,
  };
};

// Debounce utility
const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};

const AutoNeedModal = () => {
  const { selectedConvo, lodingConvo } = useSelector((state) => state.messages);
  const islogin = useSelector((state) => state.user.isLogin);
  const userData = useSelector(
    (state) => state.user.userDetails.profileDetails
  );
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const {
    searchPopUp,
    sampleAd,
    actionType,
    checkExistingError,
    checkExistingStatus,
    vTName,
    vTNumber,
    answers,
  } = useSelector((state) => state.searchBar);
  const { sendNewMessage } = useSocket();
  const { dropdownOpen } = useSelector((state) => state.bwvData);
  const { searchQuery } = useSelector((state) => state.lcAds);
  const dispatch = useDispatch();
  const formData = useSelector((state) => state.requestForm);
  const { otherVendors } = useSelector((state) => state.requestForm);
  const [isLoading, setIsLoading] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);
  const [eventDetailsError, setEventDetailsError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [secondaryPhoneError, setSecondaryPhoneError] = useState(false);
  const [zipcodeError, setZipcodeError] = useState(false);
  const [countryCodeError, setCountryCodeError] = useState(false);
  const [mandatoryQuestionsError, setMandatoryQuestionsError] = useState(false);
  const [otherVendorsError, setOtherVendorsError] = useState(false);
  const { bwvSearchQuery } = useSelector((state) => state.bwvData);
  const [receivedOtp, setReceivedOtp] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const firstInputRef = useRef(null);
  const [step, setStep] = useState(1);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("+1");
  const isAdmin = user && user.Role === "admin";
  const isVendor = user?.Role === "provider";

  // Load form data from localStorage when the dialog opens
  useEffect(() => {
    if (searchPopUp) {
      setStep(1);
      setOtp("");
      setReceivedOtp(null);
      setOtpError(false);
      setSelectedCountry("+1");
      setCountryCodeError(false);
      setMandatoryQuestionsError(false);
      setOtherVendorsError(false);
      dispatch(setShowCallDialog(false));
      dispatch(setPhone(""));
      // Load form data from localStorage if available
      const savedFormData = localStorage.getItem("EnquiryFormData");
      if (savedFormData) {
        try {
          const parsedFormData = JSON.parse(savedFormData);
          if (islogin) {
            dispatch(setEmail(user?.Email || parsedFormData.Email || ""));
            dispatch(setPhone(user?.Phone || parsedFormData.Phone || ""));
            dispatch(
              setAlternativePhoneOne(
                user?.secondaryPhone ||
                  userData?.secondaryPhone ||
                  parsedFormData.alternativePhoneOne ||
                  ""
              )
            );
            dispatch(setZipcode(user?.ZipCode || parsedFormData.Zipcode || ""));
            dispatch(setDescription(parsedFormData.Description || ""));
            dispatch(setEventDetails(parsedFormData.eventDetails || ""));
            dispatch(setNoOtherVendors(parsedFormData.noOtherVendors || false));
            if (parsedFormData.noOtherVendors) {
              dispatch(setOtherVendors([]));
            } else {
              dispatch(setOtherVendors(parsedFormData.otherVendors || []));
            }
            setSelectedCountry(
              user?.CountryCode || parsedFormData.countryCode || "+1"
            );
          } else {
            // For non-logged-in users, set all fields from parsedFormData
            dispatch(setEmail(parsedFormData.Email || ""));
            dispatch(setPhone(parsedFormData.Phone || ""));
            dispatch(
              setAlternativePhoneOne(parsedFormData.alternativePhoneOne || "")
            );
            dispatch(setZipcode(parsedFormData.Zipcode || ""));
            dispatch(setDescription(parsedFormData.Description || ""));
            dispatch(setEventDetails(parsedFormData.eventDetails || ""));
            dispatch(setNoOtherVendors(parsedFormData.noOtherVendors || false));
            if (parsedFormData.noOtherVendors) {
              dispatch(setOtherVendors([]));
            } else {
              dispatch(setOtherVendors(parsedFormData.otherVendors || []));
            }
            setSelectedCountry(parsedFormData.countryCode || "+1");
          }
        } catch (error) {
          console.error("Error parsing savedFormData:", error);
        }
      } else if (islogin) {
        // If no saved data, set defaults for logged-in users
        dispatch(setEmail(user?.Email || ""));
        dispatch(setPhone(user?.Phone || ""));
        dispatch(
          setAlternativePhoneOne(
            user?.secondaryPhone || userData?.secondaryPhone || ""
          )
        );
        dispatch(setZipcode(user?.ZipCode || ""));
        dispatch(setDescription(""));
        dispatch(setEventDetails(""));
        dispatch(setNoOtherVendors(false));
        dispatch(setOtherVendors([]));
        setSelectedCountry(user?.CountryCode || "+1");
      }
    }
  }, [searchPopUp]);

  const handleClose = () => {
    dispatch(setSearchPopUp(false));
    dispatch(setDescription(""));
    setDescriptionError(false);
    setEventDetailsError(false);
    setEmailError(false);
    setPhoneError(false);
    setSecondaryPhoneError(false);
    setZipcodeError(false);
    setCountryCodeError(false);
    setOtpError(false);
    setMandatoryQuestionsError(false);
    setOtherVendorsError(false);
    setStep(1);
    dispatch(setShowCallDialog(false));
  };

  const validateEventDetails = (eventDetails) => {
    if (!eventDetails) return false;
    try {
      const event = JSON.parse(eventDetails)[0];
      return (
        event.eventDate &&
        event.eventTime &&
        event.eventType &&
        event.eventLocation &&
        event.totalGuestCount &&
        event.eventDate.trim() !== "" &&
        event.eventTime.trim() !== "" &&
        event.eventType.trim() !== "" &&
        event.eventLocation.trim() !== "" &&
        event.totalGuestCount.trim() !== ""
      );
    } catch (error) {
      console.error("Error parsing eventDetails:", error);
      return false;
    }
  };

  const validateMandatoryQuestions = () => {
    if (formData.engagedCouple !== 1 || !sampleAd?.Questions) return true;
    try {
      const parsedQuestions = JSON.parse(sampleAd.Questions);
      return parsedQuestions.every((question) => {
        if (!question.mandatory) return true;
        const answer = answers[question.label];
        if (question.type === "text" && (!answer || answer.trim() === "")) {
          return false;
        }
        if (question.type === "options" && (!answer || answer === "")) {
          return false;
        }
        if (question.type === "check" && answer !== true) {
          return false;
        }
        return true;
      });
    } catch (error) {
      console.error(
        "Failed to parse sampleAd.Questions for validation:",
        error
      );
      return true;
    }
  };

  const validateForm = () => {
    let isValid = true;

    if (!islogin && !formData.Email) {
      setEmailError(true);
      toast.error("Email is required");
      isValid = false;
    }
    if (!formData.Zipcode || !/^\d{5}$/.test(formData.Zipcode)) {
      setZipcodeError(true);
      toast.error("Valid 5-digit zipcode is required");
      isValid = false;
    }
    if (!formData.Phone || formData.Phone.length !== 10) {
      setPhoneError(true);
      toast.error("Valid 10-digit phone number is required");
      isValid = false;
    }
    if (
      !formData.alternativePhoneOne ||
      formData.alternativePhoneOne.length !== 10
    ) {
      setSecondaryPhoneError(true);
      toast.error("Valid 10-digit secondary phone number is required");
      isValid = false;
    }
    if (formData.alternativePhoneOne === formData.Phone) {
      setSecondaryPhoneError(true);
      toast.error(
        "Secondary phone number should be different from primary phone number"
      );
      isValid = false;
    }
    if (!selectedCountry) {
      setCountryCodeError(true);
      toast.error("Please select a country code");
      isValid = false;
    }
    if (!formData?.Description || formData?.Description.trim() === "") {
      setDescriptionError(true);
      toast.error("Description is required");
      isValid = false;
    }
    if (formData.engagedCouple === 1) {
      const isEventDetailsValid = validateEventDetails(formData.eventDetails);
      if (!isEventDetailsValid) {
        setEventDetailsError(true);
        toast.error("Please fill in all event details");
        isValid = false;
      }
      const isQuestionsValid = validateMandatoryQuestions();
      if (islogin && !isQuestionsValid) {
        setMandatoryQuestionsError(true);
        toast.error("Please answer all mandatory questions");
        isValid = false;
      }
    }
    if (formData.engagedCouple === 1 && formData.otherVendors.length > 0) {
      if (!formData.noOtherVendors) {
        if (formData.otherVendors.length === 0) {
          setOtherVendorsError(true);
          toast.error(
            "Please select at least one vendor or check 'I don't need other vendors.'"
          );
          isValid = false;
        }
      }
    }
    return isValid;
  };

  useEffect(() => {
    if (searchPopUp && firstInputRef.current) {
      firstInputRef.current.focus();
    }
  }, [searchPopUp, step]);

  const handleBackdropClick = (event) => {
    event.stopPropagation();
  };

  useEffect(() => {
    if (checkExistingStatus === "failed" && checkExistingError) {
      toast.error(checkExistingError);
    }
  }, [checkExistingStatus, checkExistingError]);

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };

  const handleStartZoomCall = async () => {
    const { toast, makeCall, GetZoomLink, sendMsgMail, virtualTourClick } =
      await loadUtilities();
    if (!islogin && !vTName) {
      toast.error("Please Enter Email");
      return;
    }
    if (!islogin && !vTNumber) {
      toast.error("Please Enter Phone Number");
      return;
    }
    const serviceInfo = JSON.parse(sampleAd?.additionalPeople || "[]");
    const newPerson1 = {
      email: !islogin ? vTName : user?.Email,
      phoneNumber: !islogin ? vTNumber : user?.Phone,
      countryCode: !islogin ? selectedCountry : user?.CountryCode,
    };
    let newPerson2;
    let newPerson3;
    if (sampleAd.profilePhone === sampleAd.Phone) {
      newPerson2 = {
        email: sampleAd?.Email,
        phoneNumber: sampleAd?.profilePhone,
        countryCode: sampleAd?.countryCode,
      };
    } else {
      newPerson2 = {
        email: sampleAd?.Email,
        phoneNumber: sampleAd?.profilePhone,
        countryCode: sampleAd?.countryCode,
      };
      newPerson3 = {
        email: sampleAd?.Email,
        phoneNumber: sampleAd?.Phone,
        countryCode: sampleAd?.countryCode,
      };
    }
    serviceInfo.unshift(newPerson1);
    serviceInfo.push(newPerson2);
    if (newPerson3) serviceInfo.push(newPerson3);
    const stringifiedAdditionalPeople = JSON.stringify(serviceInfo);
    let formData = {
      email: !islogin ? vTName : user?.Email,
      phoneNumber: !islogin ? vTNumber : user?.Phone,
      countryCode: !islogin ? selectedCountry : user?.CountryCode,
      phoneDetails: stringifiedAdditionalPeople,
      similarLocalVendor: sampleAd?.similarLocalVendor,
      customerName: `${user?.FirstName} ${user?.LastName}`,
      serviceId: sampleAd?.Id,
      customerId: user?.UserID,
    };
    const response = await makeCall(formData);
    toast.success(
      "Calling the Vendor now, Please Standby as we attempt to get them on the call"
    );
    if (response === "initiating call") {
      const formData = {
        startTime: formatDate(new Date()),
        needName: sampleAd?.listName,
      };
      const linkResponse = await GetZoomLink(formData, sampleAd?.Id);
      dispatch(setLink(linkResponse.join_url));
      let formData1 = {
        zoomlink: linkResponse.join_url,
        phoneDetails: stringifiedAdditionalPeople,
        customerId: user?.UserID,
        ownerId: parseInt(sampleAd?.createdBy),
        Type: "details",
        postId: sampleAd?.Id,
        postName: sampleAd?.listName,
      };
      await sendMsgMail(formData1);
      dispatch(setIsZoomStarted(true));
      await virtualTourClick(sampleAd?.Id);
    } else {
      throw new Error("Response from makeCall was invalid");
    }
  };

  const handleSendOtp = async () => {
    const { axiosClient, toast } = await loadUtilities();
    if (!validateForm()) return;
    if (isLoading) return;
    setIsLoading(true);
    try {
      const userData = {
        email: formData.Email,
        Phone: formData.Phone,
        country_code: selectedCountry,
        action: "SIGNUP",
      };
      const response = await axiosClient.post("otp/SendOtp", userData);
      console.log("Send OTP response:", response.data);
      if (response.data.statusCode === 200 && response.data.data?.otp) {
        setReceivedOtp(String(response.data.data.otp));
        toast.success(`Code sent to Phone ${formData.Phone}`);
        setStep(2);
      } else {
        console.error("Invalid OTP response:", response.data);
        toast.error(response.data.message || "Failed to send OTP");
      }
    } catch (error) {
      console.error("Error during OTP sending:", error);
      toast.error("Error sending OTP");
    } finally {
      setIsLoading(false);
    }
  };
  console.log(selectedConvo, "selectedConvo");
  const handleVerifyOtp = async (e) => {
    const { toast } = await loadUtilities();
    e.preventDefault();
    if (!otp || otp.length !== 4) {
      setOtpError(true);
      toast.error("Please enter a 4-digit OTP");
      return;
    }
    if (isLoading) return;
    setIsLoading(true);
    try {
      console.log("Verifying OTP:", {
        otp,
        receivedOtp,
        types: { otp: typeof otp, receivedOtp: typeof receivedOtp },
      });
      // if (otp === receivedOtp || otp === "9999") {
      if (otp === receivedOtp) {
        toast.success("OTP verified successfully");
        await proceedResults();
      } else {
        setOtpError(true);
        toast.error("Invalid OTP");
      }
    } catch (error) {
      console.error("Error during OTP verification:", error);
      setOtpError(true);
      toast.error("Error verifying OTP");
    } finally {
      setIsLoading(false);
    }
  };

  const debouncedSetOtp = debounce((value) => {
    setOtp(value);
    console.log("Debounced OTP set:", value);
  }, 100);

  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 4);
    console.log("Raw input value:", value);
    debouncedSetOtp(value);
    setOtpError(false);
  };

  useEffect(() => {
    if (otp.length === 4) {
      handleVerifyOtp({ preventDefault: () => {} });
    }
  }, [otp]);

  const MessageSend = async (
    parent,
    userId,
    fullName,
    createdEmail,
    userRole
  ) => {
    const description =
      !sampleAd?.Questions &&
      Object.keys(answers || {}).length === 0 &&
      (!formData?.eventDetails || formData?.engagedCouple !== 1)
        ? formData?.Description || ""
        : (formData?.Description || "") +
          (sampleAd?.Questions && Object.keys(answers || {}).length > 0
            ? "<br/>" +
              Object.entries(answers)
                .map(([label, answer], index) => {
                  try {
                    const parsedQuestions = JSON.parse(sampleAd.Questions);
                    const question = parsedQuestions.find(
                      (q) => q.label === label
                    );
                    if (!question) return "";
                    return `${index + 1}. <b>${label}</b><br/>${answer}<br/>`;
                  } catch (error) {
                    console.error("Failed to parse sampleAd.Questions:", error);
                    return "";
                  }
                })
                .filter(Boolean)
                .join("")
            : "") +
          (formData?.engagedCouple === 1 && formData?.eventDetails
            ? "<br/><b>Event Details:</b><br/>" +
              (Array.isArray(JSON.parse(formData.eventDetails || "[]")) &&
              JSON.parse(formData.eventDetails || "[]").length > 0
                ? JSON.parse(formData.eventDetails)
                    .map((event, index) => {
                      return (
                        `${index + 1}. ` +
                        `<b>Event Date:</b> ${new Date(
                          event.eventDate
                        ).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })}<br/>` +
                        `<b>Event Time:</b> ${event.eventTime}<br/>` +
                        `<b>Event Type:</b> ${event.eventType}<br/>` +
                        `<b>Event Location:</b> ${event.eventLocation}<br/>` +
                        `<b>Total Guest Count:</b> ${event.totalGuestCount}<br/>`
                      );
                    })
                    .join("<br/>")
                : "")
            : "") +
          (otherVendors.length > 0
            ? "<br/><b>Other Vendors Needed:</b><br/>" +
              otherVendors
                .map((vendor, index) => `${index + 1}. ${vendor}<br/>`)
                .join("")
            : formData.noOtherVendors
            ? "<br/><b>Other Vendors Needed:</b> None<br/>"
            : "");
    const messageForm = {
      customerId: sampleAd?.createdBy || "0",
      postId: sampleAd?.Id || "0",
      postType: 1,
      Description: description,
      messageStatus: 8,
      createdBy: userId, // Use updated userId
      roleId: userRole, // Use role from login response if needed
      ownerId: sampleAd?.createdBy || "0",
      userName: fullName, // Use first name from fullName
      Email: createdEmail,
      serviceNeed: formData?.engagedCouple === 1 ? "service" : "need",
      parentId: !selectedConvo
        ? parent
          ? parent.Id
          : 0
        : selectedConvo.parentId === 0
        ? selectedConvo.Id
        : selectedConvo.parentId ?? 0,
      //   parentId:
      //     selectedConvo?.parentId === 0
      //       ? selectedConvo?.Id ?? 0
      //       : selectedConvo?.parentId ?? 0,
    };
    try {
      const response = await sendMessage(messageForm);
      if (response) {
        sendNewMessage(response.Data);
      }
    } catch (error) {
      console.error("Failed to send message:", error);
      throw error;
    }
  };

  const reset = () => {
    dispatch(setDescription(""));
    dispatch(resetFormState());
    setDescriptionError(false);
    setEventDetailsError(false);
    setEmailError(false);
    setPhoneError(false);
    setSecondaryPhoneError(false);
    setZipcodeError(false);
    setCountryCodeError(false);
    setOtpError(false);
    setMandatoryQuestionsError(false);
    setOtherVendorsError(false);
    dispatch(setActionType(null));
    setStep(1);
  };

  const proceedResults = async () => {
    const { toast, postRequest, postOtherVendors } = await loadUtilities();
    if (!validateForm()) return;
    dispatch(setSearchPopUp(false));
    // Load existing form data from localStorage to preserve fields
    let existingFormData = {};
    const savedFormData = localStorage.getItem("EnquiryFormData");
    if (savedFormData) {
      try {
        existingFormData = JSON.parse(savedFormData);
      } catch (error) {
        console.error("Error parsing existing EnquiryFormData:", error);
      }
    }

    // Initialize userId and userData for logged-in or newly logged-in users
    let userId = user?.UserID || null;
    let fullName = islogin
      ? `${user?.FirstName} ${user?.LastName || ""}`
      : formData?.Email.split("@")[0].trim();
    let createdEmail = user?.Email || formData?.Email;
    let phone = user?.Phone || formData.Phone || null;
    let countryCode = islogin ? user?.CountryCode : selectedCountry;
    let userRole = islogin ? user?.RoleId : 2;
    // Handle login for non-logged-in users
    if (!islogin) {
      try {
        const response = await axiosClient.post("auth/login", {
          email: formData?.Email,
          password: null,
          ssologin: true,
        });
        if (response.data.statusCode === 200) {
          dispatch(
            userAction.setLoginInfo({
              token: response.data.token,
              userInfo: response.data.user,
            })
          );
          localStorage.setItem("USER_ROLE", response.data?.user.Role);
          // Update userId and other user-related data from the login response
          userId = response.data.user.UserID;
          fullName = `${response.data.user.FirstName} ${
            response.data.user.LastName || ""
          }`;
          createdEmail = response.data.user.Email;
          phone = response.data.user.Phone;
          countryCode = response.data.user.CountryCode;
        } else {
          console.error("Login failed:", response.data);
          toast.error(response.data.message || "Login failed");
          return;
        }
      } catch (error) {
        console.error("Error during login:", error);
        toast.error("User does not exist, please register first", {
          theme: "colored",
        });
        return;
      }
    }

    const updatedFormData = {
      ...formData,
      createdBy: userId,
      FullName: fullName,
      ...(formData.availableFrom &&
        typeof formData.availableFrom !== "string" && {
          availableFrom: JSON.stringify(formData.availableFrom),
        }),
      Title:
        (sampleAd?.Title ||
          sampleAd?.listName ||
          sampleAd?.image_title ||
          searchQuery ||
          bwvSearchQuery ||
          "") + " (Auto Generated)",
      Description: formData?.Description + " (Auto Generated Description)",
      categoryId: sampleAd?.categoryId || null,
      subCategoryId: sampleAd?.subCategoryId || null,
      itemId: sampleAd?.itemId || null,
      needRadius: user?.Radius || null,
      Zipcode: user?.ZipCode || formData.Zipcode || "",
      cityName: formData.engagedCouple === 1 ? user?.Location : null,
      Phone: phone,
      createdEmail: createdEmail,
      eventDetails: formData.engagedCouple === 1 ? formData.eventDetails : [],
      vendorId: sampleAd?.createdBy || 0,
      needType: sampleAd ? 1 : null,
      countryCode: countryCode,
      otherVendors:
        otherVendors &&
        otherVendors.length > 0 &&
        !formData.noOtherVendors &&
        formData.engagedCouple === 1
          ? JSON.stringify(otherVendors)
          : null,
      noOtherVendors: formData.engagedCouple === 1 && formData.noOtherVendors,
    };

    if (
      updatedFormData.availableFrom &&
      typeof updatedFormData.availableFrom !== "string"
    ) {
      updatedFormData.availableFrom = JSON.stringify(
        updatedFormData.availableFrom
      );
    }
    const actionRequired = async () => {
      if (actionType === "FROMLINK") {
        // handlenavFromLink();
      } else if (actionType === "CALL") {
        dispatch(setShowCallDialog(true));
      } else if (actionType === "TEXT") {
        dispatch(setIsChatModalOpen(true));
      } else if (actionType === "VISIT") {
        window.open(sampleAd.websiteLink, "_blank");
      } else if (actionType === "HIRE") {
        dispatch(setIsModalOpen(true));
        dispatch(setActionType(null));
      } else if (actionType === "VIRTUAL") {
        dispatch(setDropdownOpen(!dropdownOpen));
      } else if (actionType === "VIRTUAL_POP" || actionType === "VIDEO") {
        if (islogin || userId) {
          await handleStartZoomCall();
        }
      }
    };
    let needExists = false;
    if (islogin || userId) {
      const checkForm = {
        Title: updatedFormData.Title + " (Auto Generated)",
        userId: userId,
      };
      const result = await dispatch(checkExisting(checkForm)).unwrap();
      needExists = result.data;
    }

    if (needExists) {
      if (actionType === "FROMLINK") {
        removeFbclidFromUrl();
      }
      dispatch(setGeneratedNeedId(sampleAd?.Id));
      dispatch(setSearchPopUp(false));
      reset();
      removeFbclidFromUrl();
      return;
    }

    if (isLoading) return;
    setIsLoading(true);
    try {
      if (formData.engagedCouple === 1 && otherVendors.length > 0) {
        updatedFormData.enquiry = 1;
        await postOtherVendors(updatedFormData);
      } else {
        await postRequest(updatedFormData);
      }
      actionRequired();
      // Merge formData with existingFormData to preserve fields not updated
      const formDataToSave = {
        ...existingFormData,
        ...formData,
        countryCode: selectedCountry,
        eventDetails:
          formData.eventDetails !== undefined
            ? formData.eventDetails
            : existingFormData.eventDetails || "",
        otherVendors:
          formData.otherVendors !== undefined
            ? formData.otherVendors
            : existingFormData.otherVendors || [],
        noOtherVendors:
          formData.noOtherVendors !== undefined
            ? formData.noOtherVendors
            : existingFormData.noOtherVendors || false,
      };
      localStorage.setItem("EnquiryFormData", JSON.stringify(formDataToSave));
      toast.success(
        `Inquiry sent successfully for ${
          sampleAd?.Title || sampleAd?.listName || ""
        }`
      );

      if (sampleAd?.createdBy) {
        const req = {
          customerId: +sampleAd?.createdBy,
          needId: sampleAd?.Id || sampleAd?.id,
          createdBy: userId, // Use updated userId
        };
        const response = await getAllMessages(req);
        const filterParent = response.filter((msg) => msg.parentId == 0);
        await MessageSend(
          filterParent[0],
          userId,
          fullName,
          createdEmail,
          userRole
        );
      }
      dispatch(setGeneratedNeedId(sampleAd?.Id));
      dispatch(setSearchPopUp(false));
      reset();
      removeFbclidFromUrl();
    } catch (error) {
      console.error("Post request error:", error);
      reset();
      removeFbclidFromUrl();
    } finally {
      setIsLoading(false);
    }
  };

  const handleBack = () => {
    setStep(1);
    setOtp("");
    setOtpError(false);
  };

  if (isAdmin || isVendor) return null;
  const removeFbclidFromUrl = () => {
    const url = new URL(window.location.href);
    if (url.searchParams.has("fbclid")) {
      url.searchParams.delete("fbclid");
      window.history.replaceState({}, document.title, url.toString());
    }
  };

  return (
    <React.Fragment>
      <Dialog
        open={searchPopUp}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        PaperProps={{
          style: {
            maxWidth: `${formData.engagedCouple === 1 ? "1000px" : "600px"}`,
            zIndex: 1085,
          },
        }}
        sx={{ zIndex: 1085 }}
        BackdropProps={{
          onClick: handleBackdropClick,
          style: { zIndex: 1085 },
        }}
      >
        <Button
          onClick={handleClose}
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            zIndex: 1,
          }}
          aria-label="close"
        >
          <FaWindowClose />
        </Button>
        <DialogTitle id="alert-dialog-title">
          {step === 1
            ? formData.engagedCouple !== 1 || bwvSearchQuery
              ? "Please provide details on what you are seeking"
              : `Send your inquiry to ${sampleAd?.listName || "vendor"}`
            : "Enter OTP"}
        </DialogTitle>
        <DialogContent>
          {step === 1 && (
            <AutoNeedForm
              islogin={islogin}
              formData={formData}
              dispatch={dispatch}
              firstInputRef={firstInputRef}
              selectedCountry={selectedCountry}
              setSelectedCountry={setSelectedCountry}
              emailError={emailError}
              setEmailError={setEmailError}
              zipcodeError={zipcodeError}
              setZipcodeError={setZipcodeError}
              phoneError={phoneError}
              setPhoneError={setPhoneError}
              secondaryPhoneError={secondaryPhoneError}
              setSecondaryPhoneError={setSecondaryPhoneError}
              countryCodeError={countryCodeError}
              setCountryCodeError={setCountryCodeError}
              descriptionError={descriptionError}
              setDescriptionError={setDescriptionError}
              mandatoryQuestionsError={mandatoryQuestionsError}
              setMandatoryQuestionsError={setMandatoryQuestionsError}
              eventDetailsError={eventDetailsError}
              setEventDetailsError={setEventDetailsError}
              otherVendorsError={otherVendorsError}
              setOtherVendorsError={setOtherVendorsError}
            />
          )}
          {step === 2 && (
            <AutoNeedOtp
              firstInputRef={firstInputRef}
              otp={otp}
              handleOtpChange={handleOtpChange}
              otpError={otpError}
              handleBack={handleBack}
            />
          )}
        </DialogContent>
        <DialogActions>
          {step === 1 && (
            <Button
              onClick={islogin ? proceedResults : handleSendOtp}
              autoFocus
              disabled={isLoading}
            >
              {isLoading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : islogin ? (
                "Send Inquiry and Proceed"
              ) : (
                "Verify with OTP"
              )}
            </Button>
          )}
          {/* {step === 2 && (
            <Button
              onClick={handleVerifyOtp}
              autoFocus
              disabled={isLoading || otp.length !== 4}
            >
              {isLoading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                " Submit OTP"
              )}
            </Button>
          )} */}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default AutoNeedModal;
